module.exports = __webpack_public_path__ + "img/Druid-nightelf-m-70.7164337e.gif";